import React from 'react'

interface AvatarProps {
  src: string;
  alt: string;
  fallback: string;
}

export const Avatar: React.FC<AvatarProps> = ({ src, alt, fallback }) => (
  <div className="w-8 h-8 rounded-full overflow-hidden">
    <img src={src} alt={alt} onError={(e) => {
      e.currentTarget.onerror = null;
      e.currentTarget.src = fallback;
    }} />
  </div>
)

export const AvatarImage = Avatar;
export const AvatarFallback: React.FC<{children: React.ReactNode}> = ({ children }) => (
  <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center">
    {children}
  </div>
)